import { ServicesDataProvider } from '../context/ServicesContext';
import Services from './Services';

export default function ServicesPage() {
  return (
    <ServicesDataProvider>
      <Services />
    </ServicesDataProvider>
  );
}